export default __webpack_public_path__ + "static/media/ArraysCard.24eeb085.png";